import axios from "axios";

const baseUrl = `${process.env.REACT_APP_API_URL}/api/competition-invites`;
const getToken = () => localStorage.getItem("token");

/* ASSIGN clubs -> compétition (création invitations et tokens) */
export const assignClubsToCompetition = async ({ competition_id, club_ids = [], expires_at = null }) => {
  try {
    const token = getToken();
    const res = await axios.post(
      `${baseUrl}/assign`,
      { competition_id, club_ids, expires_at },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data; // { items: [{ invite_url, status, ... }] }
  } catch (error) {
    console.error("Erreur lors de l'affectation des clubs à la compétition:", error);
    throw error;
  }
};

/* LIST invites pour une compétition */
export const listInvitesByCompetition = async (competition_id) => {
  try {
    const token = getToken();
    const res = await axios.get(`${baseUrl}/${competition_id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data; // { items: [...] }
  } catch (error) {
    console.error("Erreur lors du chargement des invitations:", error);
    return { items: [] };
  }
};

/* UPDATE status invitation */
export const updateInviteStatus = async (inviteId, status) => {
  try {
    const token = getToken();
    const res = await axios.patch(
      `${baseUrl}/${inviteId}/status`,
      { status },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du statut d'invitation:", error);
    throw error;
  }
};

/* DELETE invitation */
export const deleteInvite = async (inviteId) => {
  try {
    const token = getToken();
    await axios.delete(`${baseUrl}/${inviteId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    console.error("Erreur lors de la suppression de l'invitation:", error);
    throw error;
  }
};
